import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FontSizes, Toggle } from '@fluentui/react';
import { useNewExperienceMutationApi, useNewExperienceStateApi, } from '../../api/me/mySettings/newExperienceApi';
import { useId } from '@fluentui/react-hooks';
/**
 * The toggle switch that switches the whole app between new and old experiences.
 */
export const NewExperienceToggle = ({ userInterface, }) => {
    const headerId = useId('new-experience-toggle--label');
    const { data, isLoading, isRefetching } = useNewExperienceStateApi(userInterface);
    const { mutateAsync, isLoading: isMutating } = useNewExperienceMutationApi(userInterface);
    const isUpdateInProgress = isLoading || isMutating || isRefetching;
    return (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ id: headerId, style: { fontSize: FontSizes.mediumPlus } }, { children: "Try the new experience" })), _jsx("p", { children: "This will enable features before they are globally available to allow you to get an early look at upcoming features. These features may be unstable or may not work correctly. We may also ask for your feedback more often when you have this enabled." }), _jsx(Toggle, { "aria-labelledby": headerId, onChange: (_, checked) => {
                    if (checked !== undefined) {
                        mutateAsync(checked);
                    }
                }, checked: data || false, disabled: isUpdateInProgress, onText: 'On (newer experiences)', offText: 'Off (more stable)' })] }));
};
